module.exports = __webpack_public_path__ + "img/getty-light.8349b97d.svg";